module.exports = __webpack_public_path__ + "static/media/Slide-3.302f2047.png";